import { liteCrmContactAttributes } from './comp_constants';

import type { InfoMapping } from './types';

export function filterLiteCrmContactColumns(columns: string[]): string[] {
  return columns.filter(column => !liteCrmContactAttributes.includes(column));
}

export function filterLiteCrmContactColumnsFromInfoMapping(
  informationMappings: InfoMapping
): void {
  Object.keys(informationMappings).forEach((key) => {
    liteCrmContactAttributes.forEach((attribute) => {
      delete informationMappings[key].mappings[attribute];
    });
  });
}